/* sola-soldout-similar.js — hydrates the "More like this — in stock" row on
 * sold-out PDPs. Primary source: Shopify product recommendations (related intent).
 * Top-up: the product's brand collection. In-stock only, current product excluded.
 */
(function () {
  if (window.__solaSim) return; window.__solaSim = true;

  var MAX_SHOWN = 8;
  var MIN_BEFORE_TOPUP = 4;

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Normalize a product from either endpoint into {handle,url,title,image,cents,available}
  function fromRecs(p) {
    return {
      handle: p.handle, url: p.url, title: p.title,
      image: p.featured_image, cents: p.price_min != null ? p.price_min : p.price,
      available: !!p.available,
    };
  }
  function fromCollection(p) {
    var av = (p.variants || []).some(function (v) { return v.available; });
    var img = p.images && p.images[0] && p.images[0].src;
    var dollars = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null;
    return {
      handle: p.handle, url: '/products/' + p.handle, title: p.title,
      image: img, cents: dollars != null ? Math.round(dollars * 100) : null,
      available: av,
    };
  }

  function init() {
    var shell = document.querySelector('[data-sola-sim]');
    if (!shell || shell.__simInit) return;
    shell.__simInit = true;
    var pid = shell.getAttribute('data-sim-product-id');
    var current = shell.getAttribute('data-sim-current');
    var brand = shell.getAttribute('data-sim-brand');

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=12&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; })
      .then(function (data) {
        var picks = (data.products || []).map(fromRecs)
          .filter(function (p) { return p.available && p.handle !== current; });
        if (picks.length >= MIN_BEFORE_TOPUP || !brand) return picks;
        return fetch('/collections/' + encodeURIComponent(brand) + '/products.json?limit=24')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .catch(function () { return { products: [] }; })
          .then(function (col) {
            var seen = {};
            picks.forEach(function (p) { seen[p.handle] = true; });
            (col.products || []).map(fromCollection).forEach(function (p) {
              if (p.available && p.handle !== current && !seen[p.handle]) {
                seen[p.handle] = true; picks.push(p);
              }
            });
            return picks;
          });
      })
      .then(function (picks) {
        picks = picks.slice(0, MAX_SHOWN);
        if (!picks.length) return;
        var list = shell.querySelector('[data-sim-list]');
        var tpl = shell.querySelector('template[data-sim-card]');
        if (!list || !tpl) return;
        picks.forEach(function (p) {
          var card = tpl.content.firstElementChild.cloneNode(true);
          card.href = p.url;
          var img = card.querySelector('.sola-sim__img');
          if (p.image) {
            img.src = p.image + (p.image.indexOf('?') < 0 ? '?width=300' : '&width=300');
            img.alt = p.title;
          } else { img.remove(); }
          card.querySelector('.sola-sim__name').textContent = p.title;
          card.querySelector('.sola-sim__price').textContent = p.cents != null ? money(p.cents) : '';
          card.addEventListener('click', function () {
            if (window.posthog && posthog.capture) posthog.capture('soldout_similar_click', { to: p.handle });
          });
          list.appendChild(card);
        });
        shell.hidden = false;
        if (shell.hasAttribute('data-sim-lazy')) shell.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        if (window.posthog && posthog.capture) posthog.capture('soldout_similar_shown', { count: picks.length });
      });
  }

  var lazy = document.querySelector('[data-sola-sim][data-sim-lazy]');
  if (lazy) document.addEventListener('sola:sim-load', init);   // in-stock PDP: load when a sold-out size is tapped
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
